import React from 'react';
import Header from '../components/Header/Header';
import SeperateHero from '../components/SpecialJoin/SeperateHero';
import Project from '../components/Projects/Project';
import ProjectBanner from '../components/Projects/ProjectBanner';
import BreadcrumbSchema from "./BreadcrumbSchema";

function Projects() {
  return (
    <div
      style={{
        background: "linear-gradient(to bottom right, rgb(59 130 246 / 0.1), rgb(168 85 247 / 0.1));",
      }}
    >
      <BreadcrumbSchema />
      <Header />

      {/* Add top margin above the ProjectBanner */}
      <div className="mt-16">
        <ProjectBanner />
      </div>

      <Project />
      <SeperateHero />
    </div>
  );
}

export default Projects;
